import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { PageHero } from "@/components/PageHero";
import { FadeUp } from "@/components/Reveal";
import { IMG } from "@/data/site";

export default function Offers() {
  return (
    <div data-testid="offers-page">
      <PageHero overline="Special Offers" title="Packages & privileges" subtitle="Curated escapes at rates worth celebrating." image={IMG.pool2} />
      <section className="py-24 md:py-40 max-w-3xl mx-auto px-6 md:px-12 text-center">
        <FadeUp>
          <Sparkles size={32} className="text-[#d4af37] mx-auto mb-8" />
          <h2 className="font-serif-display text-4xl sm:text-5xl font-light text-white leading-tight" data-testid="offers-coming-soon">
            Special offers <em className="gold-text not-italic">coming soon</em>
          </h2>
          <p className="mt-6 text-[#a3a3a3] leading-relaxed">
            We are crafting a collection of seasonal packages — honeymoon escapes, family weekends and long-stay privileges. Check back soon, or send us an enquiry and we'll share our best available rate for your dates.
          </p>
          <div className="mt-10 flex flex-wrap justify-center gap-4">
            <Link to="/book" className="btn-gold px-8 py-4 text-[12px] tracking-[0.2em] uppercase font-semibold" data-testid="offers-book-btn">Enquire for Best Rates</Link>
            <Link to="/contact" className="btn-outline-gold px-8 py-4 text-[12px] tracking-[0.2em] uppercase" data-testid="offers-contact-btn">Contact Us</Link>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
